// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__j5bOo","primary":"Button_primary__-y2Ue"};